var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup22260(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22260",
    "data-name": "Group 22260",
    transform: "translate(-628 -2045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_22251",
    "data-name": "Group 22251",
    transform: "translate(333 -781.999)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5653",
    "data-name": "Rectangle 5653",
    width: 85,
    height: 85,
    rx: 15,
    transform: "translate(295 2826.999)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "_9035575_settings_outline_icon",
    "data-name": "9035575_settings_outline_icon",
    d: "M68.468,56.366a6.117,6.117,0,1,0,5.486,5.486A6.117,6.117,0,0,0,68.468,56.366ZM83.2,62.454a14.751,14.751,0,0,1-.146,1.987l4.321,3.389a1.033,1.033,0,0,1,.234,1.314l-4.088,7.073a1.033,1.033,0,0,1-1.256.439L77.97,74.928a1.54,1.54,0,0,0-1.45.167,15.721,15.721,0,0,1-2.059,1.2,1.524,1.524,0,0,0-.843,1.16l-.643,4.577a1.059,1.059,0,0,1-1.021.876H63.779a1.062,1.062,0,0,1-1.022-.848l-.642-4.571a1.536,1.536,0,0,0-.86-1.168,14.843,14.843,0,0,1-2.051-1.2,1.529,1.529,0,0,0-1.444-.163l-4.291,1.727a1.033,1.033,0,0,1-1.256-.438l-4.088-7.073a1.032,1.032,0,0,1,.234-1.314l3.652-2.867a1.534,1.534,0,0,0,.573-1.346c-.034-.4-.055-.8-.055-1.195s.02-.79.055-1.18A1.529,1.529,0,0,0,52,59.938l-3.65-2.867a1.033,1.033,0,0,1-.227-1.308l4.088-7.073a1.033,1.033,0,0,1,1.256-.439l4.291,1.728a1.54,1.54,0,0,0,1.45-.167,15.72,15.72,0,0,1,2.059-1.2,1.524,1.524,0,0,0,.843-1.16l.643-4.577A1.059,1.059,0,0,1,63.779,42h8.176a1.062,1.062,0,0,1,1.022.848l.642,4.571a1.536,1.536,0,0,0,.86,1.168,14.843,14.843,0,0,1,2.051,1.2,1.529,1.529,0,0,0,1.444.163l4.29-1.727a1.033,1.033,0,0,1,1.256.438l4.088,7.073a1.032,1.032,0,0,1-.234,1.314l-3.652,2.867a1.534,1.534,0,0,0-.578,1.346C83.176,61.658,83.2,62.055,83.2,62.454Z",
    transform: "translate(602.633 2025.046)",
    fill: "none",
    stroke: "#6d4eec",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22260);
export default __webpack_public_path__ + "static/media/Group 22260.4ab9b193bb0aeab2df567717bbf6eddd.svg";
export { ForwardRef as ReactComponent };